export const SERVICE_CODE = {
  MONEYTREE: "MONEYTREE",
  SYRUP: "SYRUP",
  OKINV: "OKINV",
  HANA: "HC",
};

export const Message = {
  modal: {
    // 매도하기 안내
    sellInfo: {
      h1: "매도하기 안내",
      tt: "매수하신 ‘e금, e은’의 매도는\n비단 앱에서 가능합니다.\n매도를 희망하시는 회원께서는\n비단 앱의 다운로드 및 설치가 필요합니다.\n매도 대금의 인출은 비단 앱에서 본인 실명계좌 인증 후 가능합니다.",
      btnConfirm: "비단 앱 실행",
    },
    // 비단 바로가기
    goCenGold: {
      h1: "매도하기 안내",
      tt: "지금 바로 비단 앱을 실행합니다.",
      btnConfirm: "비단 앱 실행",
    },
    // 거래내역 상세보기
    tradeDetail: {
      h1: "거래내역 상세보기",
      tt: "거래내역은 최근 3건의 거래내역\n정보를 제공합니다.\n보다 상세한 거래내역 및 전체 내역은\n비단 앱에서 확인하실 수 있습니다.",
      btnConfirm: "비단 앱 실행",
    },
    // 시세차트 상세보기
    chartDetail: {
      h1: "시세차트 상세보기",
      tt: "시세차트는 최근 한달의 시세 정보를 제공합니다.\n보다 상세한 시세차트는 비단 앱에서\n확인하실 수 있습니다.",
      btnConfirm: "비단 앱 실행",
    },
  },
  display: {
    [SERVICE_CODE.SYRUP]: {
      unit: "P",
      unitName: "포인트",
      buyCash: "매수 가능 포인트",
      amount: "포인트",
      minAmount: 100,
    },
    [SERVICE_CODE.MONEYTREE]: {
      unit: "원",
      unitName: "원",
      buyCash: "보유 머니트리 캐시",
      amount: "금액",
      minAmount: 100,
    },
    [SERVICE_CODE.OKINV]: {
      unit: "원",
      unitName: "원",
      buyCash: "매수 가능 KRW",
      amount: "금액",
      minAmount: 1000,
    },
  },
};

export const STORAGE_KEY = {
  SERVICE_CODE: "cengold.external.serviceCode",
  ACCESS_TOKEN: "cengold.external.accessToken",
  ACCESS_SEQUENCE: "cengold.external.accessSequence",
};

export const CHART_COLOR = {
  STROKE: {
    peg: "#DFCE72",
    pes: "#9C9B9B",
  },
  GRADIENT: {
    peg: "#F4E7A4",
    pes: "#D6D6D6",
  },
};
